import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, Subject } from 'rxjs';

export interface AutocompleteOption {
  data: string;
  label: string;
  value: string;
}

export interface AutocompleteRequest {
  partnerId: string;
  siteId: string;
  questionId: string;
  searchString: string;
  PageSize: number;
  PageIndex: number;
  parentQuestionId?: string;
  parentQuestionCodes?: string;
  selectedQuestionCodes?: string;
}
export interface KeywordAutocompleteRequest {
  partnerId: number;
  siteId: number;
  
  searchString: string;
  searchFields: string;
}

@Injectable({ providedIn: 'root' })
export class AutocompleteService {
  private openDropdownSource = new Subject<string>();
  openDropdown$ = this.openDropdownSource.asObservable();
  notifyOpen(componentId: string) {
    this.openDropdownSource.next(componentId);
  }
  constructor(private http: HttpClient) { }

  getSuggestions(req: AutocompleteRequest, RFT: string,URL:string): Observable<AutocompleteOption[]> {
    const headers = {
      '__RequestVerificationToken': RFT || ''
    };

    return this.http.post<any>(
      URL,
      req, { headers }
    ).pipe(
      map(res => {
        return Object.entries(res.Options).map(([id, label]: any) => ({
          data: id,
          label,
          value: label
        }));
      })
    );
  }
  //getKeyWordSuggestions(req: any, RFT: string, URL: string): Observable<string[]> {
  //  const headers = {
  //    'RFT': RFT || ''
  //  };

  //  return this.http.post<any>(
  //    URL,
  //    req, { headers }
    
  //  );
  //}
  getKeyWordSuggestions(
    req: any,
    RFT: string,
    URL: string
  ): Observable<string[]> {

    const headers = {
      'RFT': RFT || ''
    };

    return this.http.post<{ Options: string[] }>(
      URL,
      req,
      { headers }
    ).pipe(
      map(res => res.Options || [])
    );
  }

  
}
